const insightsNamespace = '/insights';

const assignedTasksViewRelative = '/assigned';

const assignedTasksViewRoute = `${insightsNamespace}${assignedTasksViewRelative}`;

export const insightsNamespaces = {
    insightsNamespace,
};

export const insightsRelativeRoutes = {
    assignedTasksViewRelative,
};

export const insightsAbsoluteRoutes = {
    assignedTasksViewRoute,
};
